import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Stack.module.scss'

type Gap = '0' | '1' | '2' | '3' | '4' | '6' | '8' | '12' | '16'
type Align = 'start' | 'center' | 'end' | 'stretch'
type Justify = 'start' | 'center' | 'end' | 'between' | 'around'

interface StackProps {
  children: React.ReactNode
  gap?: Gap
  align?: Align
  justify?: Justify
}

const gapMap: Record<Gap, string> = {
  '0': styles.gap0, '1': styles.gap1, '2': styles.gap2, '3': styles.gap3,
  '4': styles.gap4, '6': styles.gap6, '8': styles.gap8, '12': styles.gap12, '16': styles.gap16,
}

const alignMap: Record<Align, string> = {
  start: styles.alignStart, center: styles.alignCenter, end: styles.alignEnd, stretch: styles.alignStretch,
}

const justifyMap: Record<Justify, string> = {
  start: styles.justifyStart, center: styles.justifyCenter, end: styles.justifyEnd,
  between: styles.justifyBetween, around: styles.justifyAround,
}

export const Stack: React.FC<StackProps> = ({
  children, gap = '4', align = 'stretch', justify = 'start',
}) => (
  <div className={cx(styles.stack, gapMap[gap], alignMap[align], justifyMap[justify])}>
    {children}
  </div>
)
